import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  NOTIFICATION_FETCH,
  NOTIFICATIONS_FETCH,
  NOTIFICATION_CREATE,
  NOTIFICATION_UPDATE,
  NOTIFICATION_DELETE,
} from '../redux/actions/types';
import { notificationFetchSuccess, notificationsFetchSuccess } from '../redux/actions/NotificationActions';
import { showErrorMessage, showSuccessMessage, hideLoader } from '../redux/actions/NotifyActions';
import { authorizationHeader, getErrorMessage } from '../util/apiUtil';
import { intl } from '../i18n/IntlGlobalProvider';
import { reset } from 'redux-form';
import axios from 'axios';
import _ from 'lodash';

// API
const notificationFetchRequest = async id =>
  await axios
    .get(`${process.env.REACT_APP_API_URL}/api/notifications/${id}`, {
      headers: authorizationHeader('bearer'),
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });

const notificationsFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_URL}/api/notifications`;
  let params = { ...payload };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .get(url, {
      headers: authorizationHeader('bearer'),
      params: params,
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

const notificationCreateRequest = async values =>
  await axios
    .post(`${process.env.REACT_APP_API_URL}/api/notifications`, values, {
      headers: authorizationHeader('bearer'),
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });

const notificationUpdateRequest = async values =>
  await axios
    .put(`${process.env.REACT_APP_API_URL}/api/notifications/${values._id}`, values, {
      headers: authorizationHeader('bearer'),
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });

const notificationDeleteRequest = async id =>
  await axios
    .delete(`${process.env.REACT_APP_API_URL}/api/notifications/${id}`, {
      headers: authorizationHeader('bearer'),
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });

// WORKER
function* notificationFetch({ payload }) {
  try {
    const data = yield call(notificationFetchRequest, payload);
    yield put(notificationFetchSuccess(data));
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* notificationsFetch({ payload }) {
  try {
    const data = yield call(notificationsFetchRequest, payload);
    yield put(notificationsFetchSuccess(data));
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* notificationCreate({ payload }) {
  try {
    const data = yield call(notificationCreateRequest, payload);
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* notificationUpdate({ payload }) {
  try {
    const data = yield call(notificationUpdateRequest, payload);
    if (data.success) {
      yield put(notificationFetchSuccess(data.success.result));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* notificationDelete({ payload: id }) {
  try {
    const data = yield call(notificationDeleteRequest, id);
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

// WATCHER
function* notificationFetchWatcher() {
  yield takeEvery(NOTIFICATION_FETCH, notificationFetch);
}

function* notificationsFetchWatcher() {
  yield takeEvery(NOTIFICATIONS_FETCH, notificationsFetch);
}

function* notificationCreateWatcher() {
  yield takeEvery(NOTIFICATION_CREATE, notificationCreate);
}

function* notificationUpdateWatcher() {
  yield takeEvery(NOTIFICATION_UPDATE, notificationUpdate);
}

function* notificationDeleteWatcher() {
  yield takeEvery(NOTIFICATION_DELETE, notificationDelete);
}

export default function* rootSaga() {
  yield all([
    fork(notificationFetchWatcher),
    fork(notificationsFetchWatcher),
    fork(notificationCreateWatcher),
    fork(notificationUpdateWatcher),
    fork(notificationDeleteWatcher),
  ]);
}
